import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  path = '' 
}) => {
  const siteTitle = 'KGC Innovations Ltd';
  const siteUrl = 'https://kgcinnovations.com';
  
  // Create full title
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Enterprise Web & Mobile Development | UK`;
  
  // Create full URL
  const fullUrl = `${siteUrl}${path}`;
  
  // Default description if none provided
  const defaultDescription = 'Expert web & mobile app development services in the UK. 10+ years experience in React, Node.js, PHP, React Native. Custom solutions for businesses.';
  const metaDescription = description || defaultDescription;
  
  // Default keywords if none provided
  const defaultKeywords = 'web development UK, mobile app development, React development, Node.js developer, PHP development, full-stack developer';
  const metaKeywords = keywords || defaultKeywords;

  useEffect(() => {
    // Update title
    document.title = fullTitle;
    
    // Helper function to update or create meta tags
    const updateMetaTag = (name, content, property = false) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector);
      
      if (!meta) {
        meta = document.createElement('meta');
        if (property) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };
    
    // Update basic meta tags
    updateMetaTag('description', metaDescription);
    updateMetaTag('keywords', metaKeywords);
    
    // Update Open Graph tags
    updateMetaTag('og:title', fullTitle, true);
    updateMetaTag('og:description', metaDescription, true);
    updateMetaTag('og:url', fullUrl, true);
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:site_name', siteTitle, true);
    
    // Update Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', fullTitle);
    updateMetaTag('twitter:description', metaDescription);
    
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = fullUrl;
    
  }, [fullTitle, metaDescription, metaKeywords, fullUrl, siteTitle]);

  return null; // This component doesn't render anything
};

export default SEO;